export default __webpack_public_path__ + "static/img5-5ced3388379a16660275aee831d65fd7.png";